<template>
    <div>
        <vue-dropzone
            id="uploadDropzone"
            ref="uploadDropzone"
            name="images"
            :options="dropzoneOptions"
            @vdropzone-success="success"
            @vdropzone-complete="complete"
            @vdropzone-file-added="addedfile"
            @vdropzone-error="error"
            style="cursor: pointer;"></vue-dropzone>
        
        <div :id="previewImgID" class="dropzone-preview-img mt-3" ref="previewDiv">
            <div class="d-flex">
                <div class="mb-3 bound-preview" v-for="(image, index) in images" :data-index="`${index}`" :key="index">
                    <div class="mr-4 preview position-relative bg-black d-flex align-items-center justify-content-center">
                        <img class="img object-fit bg-black" :src="image.url"/>
                        <a class="rounded-circle border border-danger text-danger font-12 p-2 position-absolute btn-remove" href="javascript:void(0)" @click="removedFile(index)">X</a>
                        
                    </div>
                    <div class="mr-3">
                        <p class="font-12 mb-0">Content:</p>
                        <input type="text" class="form-control" v-model="image.content"/>
                    </div>
                </div>
                <div class="mr-4 mb-3 in-progress p-3" :class="{'d-flex align-items-center': isProcessing}" v-show="isProcessing">
                    <div class="progress flex-grow-1">
                        <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
        </div>
        <p class="w-100 d-none" style="overflow: hidden;"><small class="text-muted"><i>* Drag and drop to sort</i></small></p>
        <input type="hidden" :name="hiddenName" v-model="JSON.stringify(images)">
    </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import sortable from 'html5sortable';
export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    props: ['initImages', 'hiddenName', 'imageableId', 'imageableType', 'token', 'folder'],
    data: function() {
        return {
            dropzoneOptions: {
                url: `/admin/photo?_token=${this.token}&folder=${this.folder}`,
                method: 'post',
                thumbnailWidth: 150,
                maxFilesize: 5,
                acceptedFiles: 'image/jpeg, image/png',
                paramName: 'image',
                addRemoveLinks: true,
                dictDefaultMessage: '<p class="text-center">Drop files here to upload</p>'
            },
            isProcessing: false,
            images: this.initImages || [],
            previewImgID: 'previewImg_' + new Date().getTime(),
            resultUrls: []
        };
    },
    mounted: function() {
        // sortable
        this.initSortable();
    },
    methods: {
        addedfile(file) {
            if (file.type != 'image/jpeg' && file.type != 'image/png') {
                this.$dialog.alert('Only upload jpeg、jpg、png', {
                    okText: 'OK'
                });
                return;
            } 

            if (file.size > 5242880) {
                this.$dialog.alert('Max 5 MB', {
                    okText: 'OK'
                });
                return;
            } 
            this.isProcessing = true;
        },
        success(file, response) {
            if (response) {
                response['type'] = this.type;
                response['content'] = '';
                this.images.push(response);
                this.initSortable();
            }
        },
        complete(file) {
            if (file.status == 'error') {
                this.$refs.uploadDropzone.removeFile(file);
            }
            this.isProcessing = false;
        },
        removedFile(index) {
            this.$dialog.confirm('Are you sure to delete this image?', {
                okText: 'Yes',
                cancelText: 'No'
            }).then(async () => {
                const result = await axios.post('/admin/photo/delete', {
                    public_id: this.images[index].public_id,
                    imageable_type: this.imageableType,
                    imageable_id: this.imageableId
                });
                this.images.splice(index, 1);
            }).catch(() => {});
        },
        initSortable() {
            setTimeout(() => {
                sortable(`#${this.previewImgID}`, {
                    placeholderClass: 'placeholder',
                    items: '.bound-preview'
                })[0].addEventListener('sortstop', e => {
                    const resultUrls = [];
                    const cloneImages = _.cloneDeep(this.images);
                    $(`#${this.previewImgID} .bound-preview`).each(function(index) {
                        const idx = $(this).data('index');
                        console.log('idx');
                    
                        if (cloneImages[idx]) {
                            resultUrls[index] = cloneImages[idx];
                        }
                    });
                    this.images = resultUrls;
                });
            }, 500);
        },
        error(file, message, xhr) {
            console.log(file, message, xhr);
            this.isProcessing = false;
        }
    }
};
</script>
